var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Arrow---Right-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Right-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0.21967 15.2803C-0.0465966 15.0141 -0.0708027 14.5974 0.147052 14.3038L0.21967 14.2197L6.689 7.75L0.21967 1.28033C-0.0465966 1.01406 -0.0708027 0.5974 0.147052 0.303788L0.21967 0.21967C0.485936 -0.0465965 0.9026 -0.0708027 1.19621 0.147052L1.28033 0.21967L8.28033 7.21967C8.5466 7.48594 8.5708 7.9026 8.35295 8.19621L8.28033 8.28033L1.28033 15.2803C0.987437 15.5732 0.512563 15.5732 0.21967 15.2803Z",
    fill: "#4C4C4C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.d34f71a627bee85d9383a99e0fddd14f.svg";
export { ForwardRef as ReactComponent };